import React from 'react';
import LineChartStatsWrapper from '../LineChartStatsWrapper/LineChartStatsWrapper';

export default function JobStats(props) {
  return <LineChartStatsWrapper {...props} title="Job Report" id="job" />;
}
